import { uniqueId } from "@/views/zhiji/js/common/util.js";
import { ParamError } from "@/views/zhiji/js/common/errors.js";
import i18n from "@/i18n";

export default {
    widgetName: "PlatTextLink",
    serverType: "text",
    initContent() {
        return {
            uId: uniqueId(),
            updateState: "add",
            wtType: "PlatTextLink",
            text: "",
            linkWord: []
        };
    },
    checkContent(content) {
        if (!content.text) {
            throw new ParamError(i18n.t("zhiji.answer.textWidget.noTextTip"));
        }
    },
    server2Client(content) {
        const textCvt = transText2Client(content);
        return {
            uId: uniqueId(),
            wtType: "PlatTextLink",
            text: textCvt.textStr, //TODO 转换成{{xxx}}格式的文本
            updateState: "",
            linkWord: textCvt.linkWords || [],
            cmd: content.cmd
                ? content.cmd.map(item => ({
                      type: "param",
                      key: item.key,
                      paramId: item.param_id,
                      source: item.source
                  }))
                : [],
            cmdTagClassify: content.cmd_tag_classify
                ? content.cmd_tag_classify.map(item => ({
                      type: "tag",
                      key: item.key,
                      paramId: item.param_id,
                      source: item.source
                  }))
                : []
        };
    },
    client2Server(content) {
        const textServe = transLinkWord2Server(content);
        return {
            type: "text",
            text: textServe.textStr,
            url: "",
            link_word: textServe.linkWords,
            url_type: "",
            cmd: content.cmd
                ? content.cmd.map(item => ({
                      key: item.key,
                      param_id: item.paramId,
                      source: item.source
                  }))
                : [],
            cmd_tag_classify: content.cmdTagClassify
                ? content.cmdTagClassify.map(item => ({
                      key: item.key,
                      param_id: item.paramId,
                      source: item.source
                  }))
                : []
        };
    }
};

// link_word数组转服务端格式
export function transLinkWord2Server(content) {
    let textStr = content.text;
    const linkWords = [];
    const isOld = content.isOld;
    content.linkWord.forEach(item => {
        const serveWord = {
            word: item.word,
            question_id: item.questionId ? `${item.questionId}` : "",
            link_type: item.type == "link" ? item.linkType : item.type,
            url: item.url || "",
            question: item.question || ""
        };
        if (isOld) {
            textStr = textStr.replace(`{{${item.id}}}`, item.word);
        } else {
            serveWord.index = item.id;
        }
        linkWords.push(serveWord);
    });
    return {
        textStr,
        linkWords
    };
}

// {{xxx}}格式文本转换，新老协议兼容
export function transText2Client(content) {
    let textStr = content.text;
    const linkWords = [];
    content.link_word.forEach(item => {
        const id = item.index || uniqueId();
        const htmlTemplate = `{{${id}}}`;
        linkWords.push({
            id,
            word: item.word,
            questionId: item.question_id || "",
            type: tanslinkType2Client(item.link_type),
            linkType: item.link_type,
            url: item.url,
            question: item.question || ""
        });

        // 根据有没有index判断是否需要做word到index站位符的转换
        if (!item.index) {
            textStr = textStr.replace(item.word, htmlTemplate);
        }
    });
    return {
        textStr,
        linkWords
    };
}

function tanslinkType2Client(type) {
    let newType = type;
    if (type === "custom_page" || type === "new_page") {
        newType = "link";
    }
    return newType;
}
